import React from 'react';
import api from '../config/api';
import { X } from 'lucide-react';

export function AddDomainForm({ onSuccess, onCancel }) {
  const [domain, setDomain] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);

  async function handleSubmit(e) {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      const response = await api.post('/api/domains', {
        domain_name: domain,
      });

      console.log('Domain created:', response.data);
      setDomain('');
      onSuccess();
    } catch (err) {
      const message = err.response?.data?.error || 'Failed to add domain';
      setError(message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <form onSubmit={handleSubmit} className="bg-white rounded-xl border border-slate-200 shadow-sm p-6 animate-fade-in">
      <div className="mb-6 flex justify-between items-start">
        <div>
          <h2 className="text-lg font-bold text-slate-900">Add New Domain</h2>
          <p className="text-sm text-slate-500 mt-1">Connect a domain to start receiving emails</p>
        </div>
        {onCancel && (
          <button
            type="button"
            onClick={onCancel}
            className="text-slate-400 hover:text-slate-600 p-1 rounded-lg hover:bg-slate-50 transition-colors"
          >
            <span className="sr-only">Close</span>
            <X size={20} />
          </button>
        )}
      </div>

      {error && (
        <div className="mb-6 bg-rose-50 border border-rose-200 text-rose-700 px-4 py-3 rounded-lg text-sm">
          {error}
        </div>
      )}

      <div className="flex gap-3 items-start">
        <div className="flex-1">
          <label className="sr-only">Domain Name</label>
          <input
            type="text"
            value={domain}
            onChange={(e) => setDomain(e.target.value.toLowerCase())}
            placeholder="example.com"
            className="w-full px-4 py-2.5 border border-slate-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
            required
          />
          <p className="text-xs text-slate-500 mt-2 ml-1">
            Enter the domain you want to use for email (e.g., mybusiness.com)
          </p>
        </div>

        <button
          type="submit"
          disabled={loading}
          className="bg-slate-900 hover:bg-slate-800 disabled:bg-slate-400 text-white font-semibold py-2.5 px-6 rounded-lg transition-all shadow-lg shadow-slate-900/20 whitespace-nowrap"
        >
          {loading ? 'Adding...' : 'Add Domain'}
        </button>
      </div>
    </form>
  );
}
